import DashboardLayout from "@/components/DashboardLayout";
import { PermissionGuard } from "@/components/PermissionGuard";
import UserManagementContent from "@/features/users/UserManagementContent";

export default function UserManagement() {
  return (
    <PermissionGuard permission="users:view">
      <DashboardLayout>
        <div className="space-y-6">
          <div>
            <h1 className="text-3xl font-bold">Gerenciamento de Usuarios</h1>
            <p className="text-muted-foreground mt-1">Gerencie os usuarios e seus perfis de acesso</p>
          </div>
          <UserManagementContent showHeader={false} />
        </div>
      </DashboardLayout>
    </PermissionGuard>
  );
}
